/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_MicrophoneInputs */



/**
* | output |
* | --- |
* | "Microphone" |
*
* @param {Chat_Dictate_MicrophoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_microphone = /** @type {((inputs?: Chat_Dictate_MicrophoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_MicrophoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microfoon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Micro")
	return /** @type {LocalizedString} */ ("Microphone")
});